module.exports = __webpack_public_path__ + "img/company.be72b6c8.png";